<template>
  <base-panel
    v-show="starAuthors.length"
    :title="title"
    class="base-panel"
    @toMore="redirectAuthorPage"
  >
    <ul class="star-authors">
      <li v-for="item in starAuthors" :key="item.authorId" class="star-author">
        <router-link
          class="head"
          :style="{ backgroundImage: `url(${item.headPic})` }"
          :to="`/author/${item.authorId}`"
        >
          <div class="vicon"></div>
        </router-link>
        <div>
          <router-link class="name" :to="`/author/${item.authorId}`">{{
            item.name
          }}</router-link>
          <div class="source">
            {{ item.typeName }} | {{ item.authorCompany }}
          </div>
          <div class="fans">粉丝数 {{ item.followerNum }}</div>
        </div>
      </li>
    </ul>
  </base-panel>
</template>

<script>
import BasePanel from '@/components/BasePanel/BasePanel'
import { getStarAuthors } from '@/api/account'

export default {
  name: 'StarAuthorPanel',
  components: { BasePanel },
  props: {
    type: {
      type: Number
    },
    title: {
      type: String,
      required: true
    }
  },
  data() {
    return {
      starAuthors: []
    }
  },
  created() {
    this.getStarAuthorList()
  },
  methods: {
    redirectAuthorPage() {
      this.$router.push('author')
    },
    async getStarAuthorList() {
      const data = await getStarAuthors(this.type)
      if (data) {
        this.starAuthors = data
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.base-panel {
  flex-direction: column;
}
.star-authors {
  padding: 15px 0;
}

.star-author {
  position: relative;
  display: flex;
  align-items: center;
  height: 90px;
  padding: 0 20px;
}

.head {
  width: 60px;
  height: 60px;
  background: no-repeat center;
  background-size: contain;
  border-radius: 50%;
  margin-right: 10px;
}

.name {
  font-size: 16px;
  color: #262626;
  text-decoration: none;
}

.source {
  padding: 8px 0;
  font-size: 14px;
  letter-spacing: 1px;
  color: #858585;
}

.fans {
  font-size: 14px;
  letter-spacing: 1px;
  color: #858585;
}

.vicon {
  top: 58px;
  left: 56px;
  position: absolute;
  width: 20px;
  height: 20px;
  background: url('~@/assets/images/author/vicon.png') no-repeat center;
  background-size: contain;
  border-radius: 50%;
}
</style>
